/**
 * Nhãn tiếng Việt cho mọi mã máy — **một chỗ duy nhất**.
 *
 * Rải nhãn trong từng màn là cách `PENDING_REVIEW` thành *"Chờ duyệt"* ở màn này và *"Đang chờ"*
 * ở màn kia, rồi người đọc tưởng là hai trạng thái khác nhau.
 */

import type { TrangThaiBai } from "../api.ts";

type Muc = "thuong" | "canh" | "loi" | "on" | "dam";

const NHAN: Record<TrangThaiBai, { chu: string; muc: Muc; giaiThich: string }> = {
  BRIEF_READY: { chu: "Chờ viết", muc: "thuong", giaiThich: "Đề bài đã sẵn, job viết bài chưa chạy" },
  WRITING: { chu: "Đang viết", muc: "thuong", giaiThich: "Kẹt quá 10 phút ở đây là dấu hiệu hỏng" },
  NEEDS_IMAGE: { chu: "Chờ ảnh", muc: "thuong", giaiThich: "Bài xong, chưa có ảnh" },
  PENDING_REVIEW: { chu: "Chờ duyệt", muc: "canh", giaiThich: "Đang chờ anh — con số quan trọng nhất" },
  REJECTED_TEXT: { chu: "Từ chối bài", muc: "loi", giaiThich: "Sẽ viết lại từ đầu" },
  REJECTED_IMAGE: { chu: "Từ chối ảnh", muc: "loi", giaiThich: "Chỉ vẽ lại ảnh, bài giữ nguyên" },
  APPROVED: { chu: "Đã duyệt", muc: "on", giaiThich: "Chờ xếp lịch" },
  SCHEDULED: { chu: "Đã xếp lịch", muc: "on", giaiThich: "Có giờ đăng, chưa tới giờ" },
  PUBLISHED_WEB: { chu: "Đã lên web", muc: "on", giaiThich: "Chưa đăng Facebook" },
  PUBLISHED_ALL: { chu: "Lên cả hai", muc: "on", giaiThich: "Web và Facebook đều xong" },
  FAILED: { chu: "Lỗi", muc: "loi", giaiThich: "Cần anh quyết chạy lại hay bỏ" },
  DISCARDED: { chu: "Đã bỏ", muc: "thuong", giaiThich: "Anh đã bỏ bài này" },
};

export function nhanTrangThai(t: TrangThaiBai): { chu: string; muc: Muc; giaiThich: string } {
  return NHAN[t] ?? { chu: t, muc: "thuong", giaiThich: "Trạng thái lạ — chưa có nhãn" };
}

/** Giờ Việt Nam. Database lưu UTC; đổi múi giờ **ở rìa**, đúng chỗ này. */
export function gioVN(iso: string): string {
  return new Date(iso).toLocaleString("vi-VN", {
    timeZone: "Asia/Ho_Chi_Minh",
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function daChoBaoLau(iso: string): string {
  const phut = Math.round((Date.now() - new Date(iso).getTime()) / 60_000);
  if (phut < 1) return "vừa xong";
  if (phut < 60) return `${phut} phút`;
  const gio = Math.round(phut / 60);
  if (gio < 24) return `${gio} giờ`;
  return `${Math.round(gio / 24)} ngày`;
}
